import { IStakeInfo } from "../../utils/types";
import { useTheme } from "../../context/ThemeContext";
import Input from "../Input";

const StakeInfoForm = ({ subnetId, setSubnetId, stakeAmount, setStakeAmount }: IStakeInfo) => {
  const { theme } = useTheme();
  const inputClsName = `w-full px-3 py-2 rounded-md ${theme === 'dark' ? 'dark' : ''} bg-black/10 dark:bg-white/10 text-[14px] text-black dark:text-white`
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div>
      <label htmlFor="subnetId" className="block text-sm font-medium text-black dark:text-white mb-2">
        Subnet ID
      </label>
      <Input
        props={{
          type: "number",
          id: "subnetId",
          value: subnetId,
          onChange: (e) => setSubnetId(e.target.value),
          placeholder: "Enter subnet ID",
          min: "0",
          step: "1",
          pattern: "[0-9]*",
          onKeyPress: (e) => {
            if (!/[0-9]/.test(e.key)) {
              e.preventDefault();
            }
          }
        }}
        className={inputClsName}
      />
    </div>
    <div>
      <label htmlFor="stakeAmount" className="block text-sm font-medium text-black dark:text-white mb-2">
        Stake or Unstake Amount (τ)
      </label>
      <Input
        props={{
          type: "number",
          id: "stakeAmount",
          value: stakeAmount,
          onChange: (e) => setStakeAmount(e.target.value),
          placeholder: "Enter stake amount",
          min: "0",
          step: "0.01"
        }}
        className={inputClsName}
      />
    </div>
  </div>;
};

export default StakeInfoForm;